import React, { useRef, useState } from "react";
import { Box, Button, Checkbox, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, Icon, IconButton, InputLabel, LinearProgress, MenuItem, Paper, Typography, useTheme } from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import { DatePicker, DateTimePicker } from "formik-material-ui-pickers";
import * as Yup from "yup";
import { Select, SimpleFileUpload, TextField } from "formik-material-ui";
import { useLocations } from "../../../intake/intakeQueries";
import { useAssetInsert } from "../../../dataEgress/dataEgressMutations";
import { toast } from "react-toastify";
import { useFetchContext } from "../../../common/FetchContext";
import { useAssetTypes } from "../../../testCommunication/common/testQueries";
import { CloudUpload, Delete, DeleteForever } from "@material-ui/icons";
import { usePostFile } from "../../../common/services/fileServices";
import MuiLink from "@material-ui/core/Link";
import { NewSubAsset } from "./NewSubAsset";
import { usePowerSupplySubAssetInsert } from "../stressEntry/stressEntryQueries";
import { TextField as MuiTextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import LSDBFormikAutocompleteField from "../../../common/LSDBFormikAutocompleteField";
import EditIcon from "@material-ui/icons/Edit";


export const NewAsset = () => {

    const theme = useTheme();
    const [selected, setSelected] = React.useState(false);
    const [isExterneal, setExternel] = React.useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [PowerSupplyDialog, SetPowerSupplyDialog] = useState(false);
    const [showSubAssetLink, setShowSubAssetLink] = useState(false);
    const [isMainAsset, setIsMainAsset] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [powerSupplySubAssetIds, setPowerSupplySubAssetIds] = useState<number[]>([]); // for API
    const [powerSupplySubAssetNames, setPowerSupplySubAssetNames] = useState<string[]>([]); // for display
    const [openIsExternalDialog, setOpenIsExternalDialog] = React.useState(false);
    const [externalData, setExternalData] = useState<{
        completed: string;
        date: any;
        notes: string;
    } | null>(null);



    const handleChildData = (selectedIds: number[], selectedNames: string[]) => {
        setPowerSupplySubAssetIds(selectedIds);
        setPowerSupplySubAssetNames(selectedNames);
    };



    const [files, setFiles] = React.useState([]);
    const { mutateAsync: mutatePostFile } = usePostFile();




    const { mutateAsync: mutate } = useAssetInsert();
    const { authAxios } = useFetchContext();

    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileUpload = async (item: any) => {
        fileInputRef.current?.click()
    };

    const { mutateAsync: mutatePowerSupply } = usePowerSupplySubAssetInsert();

    const handleFilePicked = (event: React.ChangeEvent<HTMLInputElement>) => {
        const uploadedFiles = event.target.files;
        if (uploadedFiles) {
            setFiles(uploadedFiles as any);
        }

    };
    const {
        error: errorLocations,
        data: locations,
        isLoading: isLoadingLocations,
        isError: isErrorLocations,
    } = useLocations();


    const {
        error: errorAssetTypes,
        data: assetTypes,
        isLoading: isLoadingAssetTypes,
        isError: isErrorAssetTypes,
    } = useAssetTypes();



    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {

            setConfirmDialogOpen(true);
        } else {

            setIsMainAsset(false);
        }
    };

    const handleConfirm = () => {

        setIsMainAsset(true);
        setConfirmDialogOpen(false);
    };

    const handleCancel = () => {
        setIsMainAsset(false);
        setConfirmDialogOpen(false);
    };
    const handlePowerSupplyCancel = () => {
        setShowSubAssetLink(false);
        setIsMainAsset(false);
        SetPowerSupplyDialog(false);
    };
    const handlePowerSupplyConfirm = () => {
        setShowSubAssetLink(true);
        setIsMainAsset(false);
        SetPowerSupplyDialog(false);
    };




    const handleOpenDialog = () => {

        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };






    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelected(event.target.checked);
    };

    const handleChangeExterneal = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;

        setExternel(checked);

        if (checked) {
            setOpenIsExternalDialog(true);
        } else {
            setExternalData(null);
        }
    };

    const [checked, setChecked] = React.useState({
        visual_inspection: false,
        trmperature: false,
        angle_measurement: false,
        humidity: false,
        uv: false,
        insulation_test: false,
    });

    const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked({
            ...checked,
            [event.target.value]: event.target.checked,
        });
    };

    const { visual_inspection, trmperature, angle_measurement, humidity, uv, insulation_test } = checked;
    const error = [visual_inspection, trmperature, angle_measurement, humidity, uv, insulation_test].filter((v) => v).length !== 0;

    if (isLoadingAssetTypes || isLoadingLocations) {
        return <LinearProgress />
    }

    return (
        <div style={theme.container}>
            <Container maxWidth="sm">
                <Grid
                    container
                    direction="row"
                    justify="space-around"
                    alignItems="center"
                    spacing={2}
                >

                    <Grid item xs={12}>
                        <Formik
                            initialValues={{
                                asset_id: "",
                                asset_name: "",
                                description: "",
                                location_id: "",
                                manufacturer_name: "",
                                model: "",
                                serial_number: "",
                                schedule_for_the_calibration: 0,
                                days_since_calibrated: "",
                                days_to_next_calibrated: "",
                                nextcalibrateddate: new Date(),
                                lastactiondateTime: new Date(),
                                lastcalibrateddate: new Date(),
                                isCalibration: selected,
                                asset_type_id: "",
                                external_asset_required: isExterneal,
                                is_main_asset: isMainAsset,
                                external_completed: "",
                                external_completed_date: null,
                                external_notes: "",



                            }}


                            validationSchema=
                            {Yup.object(
                                {
                                    asset_id: Yup.string().required("Field must be required"),
                                    asset_name: Yup.string().required("Field must be required"),
                                    description: Yup.string().required("Field must be required"),
                                    location_id: Yup.string().required("Field must be required"),
                                    asset_type_id: Yup.string().required("Field must be required"),
                                    manufacturer_name: Yup.string().required("Field must be required"),
                                    model: Yup.string().required("Field must be required"),
                                    serial_number: Yup.string().required("Field must be required"),
                                    lastcalibrateddate: Yup.string().required("Field must be required"),
                                })}

                            onSubmit={async (values, { setSubmitting }) => {


                                try {

                                    let newAssetData;

                                    var usages = "";

                                    if (checked.visual_inspection) {

                                        usages = "Visual Inspection"

                                    }
                                    if (checked.angle_measurement) {
                                        usages = usages + ", Angle Measurement"

                                    }
                                    if (checked.humidity) {

                                        usages = usages + ", Humidity"

                                    }
                                    if (checked.uv) {

                                        usages = usages + ", UV"

                                    }
                                    if (checked.trmperature) {

                                        usages = usages + ", Temparature"

                                    }

                                    if (checked.insulation_test) {

                                        usages = usages + ", Insulation Test"
                                    }

                                    if (selected) {
                                        if (files.length > 0) {
                                            for (let file of files) {
                                                const postedFile = await mutatePostFile({ authAxios, file });

                                                newAssetData = await mutate({
                                                    authAxios,
                                                    asset_number: values.asset_id,
                                                    asset_name: values.asset_name,
                                                    description: values.description,
                                                    last_action_datetime: values.lastactiondateTime,
                                                    location: values.location_id,
                                                    manufacturer: values.manufacturer_name,
                                                    usage: usages,
                                                    model: values.model,
                                                    serial_number: values.serial_number,
                                                    is_calibration_required: selected,
                                                    last_calibrated_date: values.lastcalibrateddate,
                                                    schedule_for_calibration: values.schedule_for_the_calibration,
                                                    external_asset_required: isExterneal,
                                                    is_main_asset: isMainAsset,
                                                    asset_type: values.asset_type_id,
                                                    azurefile: postedFile.url,
                                                    functionality_check: values.external_completed,
                                                    date_completed: values.external_completed_date,
                                                    comments: values.external_notes

                                                });
                                            }
                                        } else {


                                            newAssetData = await mutate({
                                                authAxios,
                                                asset_number: values.asset_id,
                                                asset_name: values.asset_name,
                                                description: values.description,
                                                last_action_datetime: values.lastactiondateTime,
                                                location: values.location_id,
                                                manufacturer: values.manufacturer_name,
                                                usage: usages,
                                                model: values.model,
                                                serial_number: values.serial_number,
                                                is_calibration_required: selected,
                                                last_calibrated_date: values.lastcalibrateddate,
                                                schedule_for_calibration: values.schedule_for_the_calibration,
                                                external_asset_required: isExterneal,
                                                is_main_asset: isMainAsset,
                                                asset_type: values.asset_type_id,
                                                functionality_check: values.external_completed,
                                                date_completed: values.external_completed_date,
                                                comments: values.external_notes

                                            });
                                        }
                                    } else {

                                        newAssetData = await mutate({
                                            authAxios,
                                            asset_number: values.asset_id,
                                            asset_name: values.asset_name,
                                            description: values.description,
                                            last_action_datetime: values.lastactiondateTime,
                                            location: values.location_id,
                                            manufacturer: values.manufacturer_name,
                                            usage: usages,
                                            model: values.model,
                                            serial_number: values.serial_number,
                                            is_calibration_required: selected,
                                            external_asset_required: isExterneal,
                                            is_main_asset: isMainAsset,
                                            asset_type: values.asset_type_id,

                                        });

                                    }

                                    if (newAssetData?.id && powerSupplySubAssetIds.length) {
                                        await mutatePowerSupply({
                                            authAxios,
                                            sub_asset_ids: powerSupplySubAssetIds,
                                            asset_calibration_id: newAssetData.id,
                                        });
                                    }

                                    toast.success("Asset Created Successfully");
                                    window.location.reload();


                                } catch (error) {
                                    toast.error("Asset Not Created");

                                }


                            }}>

                            {({ errors, touched, submitForm, resetForm, values, setFieldValue }) => {

                                const selectedAssetType = assetTypes?.find((asset: any) => {
                                    return (
                                        asset.url === values.asset_type_id
                                    )
                                })


                                return (
                                    <Form>
                                        <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            alignItems="center"
                                            spacing={4}
                                        >
                                            <Grid item xs={6}>
                                                <Field
                                                    id="asset_id"
                                                    type="text"
                                                    name="asset_id"
                                                    fullWidth
                                                    component={TextField}
                                                    style={{ marginBottom: 20 }}
                                                    helperText={
                                                        touched.asset_id ? errors.asset_id : ""
                                                    }
                                                    error={
                                                        touched.asset_id && Boolean(errors.asset_id)
                                                    }
                                                    label="Asset Number">
                                                </Field>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={isMainAsset}
                                                            onChange={handleCheckboxChange}
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Is Primary Asset"
                                                />


                                            </Grid>

                                            <Grid item xs={6}>
                                                <Field
                                                    id="asset_name"
                                                    type="null"
                                                    name="asset_name"
                                                    fullWidth
                                                    component={TextField}
                                                    style={{ marginBottom: 20 }}
                                                    label="Asset Name"
                                                    helperText={
                                                        touched.asset_name ? errors.asset_name : ""
                                                    }
                                                    error={
                                                        touched.asset_name && Boolean(errors.asset_name)
                                                    }
                                                >
                                                </Field>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Field
                                                    id="description"
                                                    type="text"
                                                    name="description"
                                                    fullWidth
                                                    component={TextField}
                                                    style={{ marginBottom: 20 }}
                                                    label="Description"
                                                    helperText={
                                                        touched.description ? errors.description : ""
                                                    }
                                                    error={
                                                        touched.description && Boolean(errors.description)
                                                    }
                                                >
                                                </Field>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Field
                                                    name="lastactiondateTime"
                                                    component={DateTimePicker}
                                                    format="YYYY-MM-DD"
                                                    style={{ marginBottom: 20 }}
                                                    label="Last action date-time"
                                                    inputVariant="standard"
                                                    fullWidth
                                                    helperText={
                                                        touched.lastactiondateTime ? errors.lastactiondateTime : ""
                                                    }
                                                    error={
                                                        touched.lastactiondateTime && Boolean(errors.description)
                                                    }
                                                />
                                            </Grid>

                                            <Grid item xs={6}>
                                                {/* <Field
                                                    id="asset_type_id"
                                                    type="text"
                                                    name="asset_type_id"
                                                    fullWidth
                                                    component={Select}
                                                    style={{ marginBottom: 20 }}
                                                    label="Asset Type"

                                                    helperText={
                                                        touched.asset_type_id ? errors.asset_type_id : ""
                                                    }
                                                    error={
                                                        touched.asset_type_id && Boolean(errors.asset_type_id)
                                                    }
                                                    onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                                                        const value = event.target.value as string;
                                                        setFieldValue("asset_type_id", value);


                                                        const selectedAssetType = assetTypes?.find(
                                                            (asset: any) => asset.url === value
                                                        );

                                                        if (selectedAssetType?.id === 66) {
                                                            SetPowerSupplyDialog(true);
                                                        }
                                                    }}
                                                >
                                                    {assetTypes?.map((location: any) => (
                                                        <MenuItem
                                                            key={location.id}
                                                            value={location.url}
                                                        >
                                                            {location.name}
                                                        </MenuItem>
                                                    ))}
                                                </Field> */}
                                                <Autocomplete
                                                    options={assetTypes || []}
                                                    getOptionLabel={(option: any) => option.name || ""}
                                                    value={
                                                        assetTypes?.find(
                                                            (asset: any) => asset.url === values.asset_type_id
                                                        ) || null
                                                    }
                                                    onChange={(event: any, newValue: any) => {
                                                        const value = newValue ? newValue.url : "";
                                                        setFieldValue("asset_type_id", value);

                                                        if (newValue?.id === 66) {
                                                            SetPowerSupplyDialog(true);
                                                        }
                                                    }}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            label="Asset Type"
                                                            variant="standard"
                                                            fullWidth
                                                            style={{ marginBottom: 20 }}
                                                            error={
                                                                touched.asset_type_id && Boolean(errors.asset_type_id)
                                                            }
                                                            helperText={
                                                                touched.asset_type_id ? errors.asset_type_id : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Dialog open={PowerSupplyDialog} onClose={handlePowerSupplyCancel}>
                                                <DialogTitle>Confirmation Dialog</DialogTitle>
                                                <DialogContent>
                                                    Do you want this asset as the PowerSupplyRack?
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handlePowerSupplyCancel} color="secondary">Cancel</Button>
                                                    <Button onClick={handlePowerSupplyConfirm} color="primary">Confirm</Button>
                                                </DialogActions>
                                            </Dialog>
                                            <Grid item xs={6}>
                                                {selectedAssetType?.id === 66 && showSubAssetLink && (
                                                    <>

                                                        <MuiLink variant="subtitle1" onClick={handleOpenDialog} >
                                                            Add Sub Asset
                                                        </MuiLink>

                                                    </>

                                                )}
                                            </Grid>

                                            <Grid item xs={6}>
                                                {powerSupplySubAssetNames.map((name) => (
                                                    <Typography key={name} style={{ margin: "10px", padding: "4px" }}>
                                                        {name}
                                                    </Typography>
                                                ))}

                                            </Grid>

                                        </Grid>

                                        <div>
                                            <Box paddingTop={4} paddingBottom={1}>
                                                <Typography variant="subtitle1" color="secondary">
                                                    Usage
                                                </Typography>
                                            </Box>

                                        </div>

                                        <FormGroup>

                                            <FormControlLabel
                                                control={<Checkbox value="visual_inspection" color="primary" onChange={handleCheckBoxChange} />}
                                                label="Visual Inspection"
                                            />

                                            <br />

                                            <FormControlLabel
                                                control={<Checkbox value="trmperature" color="primary" onChange={handleCheckBoxChange} />}
                                                label="Temperature"
                                            />

                                            <br />

                                            <FormControlLabel
                                                control={<Checkbox value="insulation_test" color="primary" onChange={handleCheckBoxChange} />}
                                                label="Insulation Test"
                                            />

                                            <br />


                                            <FormControlLabel
                                                control={<Checkbox value="angle_measurement" color="primary" onChange={handleCheckBoxChange} />}
                                                label="Incident Angle Measurement"
                                            />

                                            <br />

                                            <FormControlLabel
                                                control={<Checkbox value="humidity" color="primary" onChange={handleCheckBoxChange} />}
                                                label="Humidity"
                                            />

                                            <br />

                                            <FormControlLabel
                                                control={<Checkbox value="uv" color="primary" onChange={handleCheckBoxChange} />}
                                                label="UV"
                                            />

                                            <br />

                                        </FormGroup>


                                        <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            style={{ marginBottom: 18 }}
                                            alignItems="center"
                                            spacing={4}
                                        >

                                            <Grid item xs={6}>
                                                {/* <Field
                                                    id="location_id"
                                                    type="text"
                                                    name="location_id"
                                                    fullWidth
                                                    component={Select}
                                                    style={{ marginBottom: 20 }}
                                                    label="Location"
                                                    helperText={
                                                        touched.location_id ? errors.location_id : ""
                                                    }
                                                    error={
                                                        touched.location_id && Boolean(errors.location_id)
                                                    }
                                                >
                                                    {locations?.map((location: any) => (
                                                        <MenuItem
                                                            key={location.id}
                                                            value={location.url}
                                                        >
                                                            {location.name}
                                                        </MenuItem>
                                                    ))}
                                                </Field> */}
                                                <LSDBFormikAutocompleteField
                                                    fieldId="location_id"
                                                    fieldName="location_id"
                                                    fieldDisplayName="Location"
                                                    options={locations}
                                                    getOptionLabel={(location: any) => location.name}
                                                    getOptionValue={(location: any) => location.url}
                                                    fullWidth={true}
                                                    variant="standard"
                                                />
                                            </Grid>


                                            <Grid item xs={6}>
                                                <Field
                                                    id="manufacturer_name"
                                                    type="text"
                                                    name="manufacturer_name"
                                                    fullWidth
                                                    component={TextField}
                                                    style={{ marginBottom: 20 }}
                                                    helperText={
                                                        touched.manufacturer_name ? errors.manufacturer_name : ""
                                                    }
                                                    error={
                                                        touched.manufacturer_name && Boolean(errors.manufacturer_name)
                                                    }
                                                    label="Manufacturer name"
                                                >
                                                </Field>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Field
                                                    id="model"
                                                    type="text"
                                                    name="model"
                                                    fullWidth
                                                    component={TextField}
                                                    helperText={
                                                        touched.model ? errors.model : ""
                                                    }
                                                    error={
                                                        touched.model && Boolean(errors.model)
                                                    }
                                                    label="Model"
                                                >
                                                </Field>
                                            </Grid>


                                            <Grid item xs={6}>
                                                <Field
                                                    id="serial_number"
                                                    type="text"
                                                    name="serial_number"
                                                    fullWidth
                                                    component={TextField}
                                                    helperText={
                                                        touched.serial_number ? errors.serial_number : ""
                                                    }
                                                    error={
                                                        touched.serial_number && Boolean(errors.serial_number)
                                                    }
                                                    label="Serial Number"
                                                >
                                                </Field>
                                            </Grid>

                                        </Grid>


                                        <div>
                                            <Box paddingTop={2} paddingBottom={1}>
                                                <Typography variant="subtitle1" color="secondary">
                                                    Calibration Details
                                                </Typography>
                                            </Box>

                                        </div>


                                        <FormControlLabel
                                            control={<Checkbox value="isCalibration" color="primary" onChange={handleChange} />}
                                            label="Is calibration required or not?"
                                        />

                                        {selected && (


                                            <Grid
                                                container
                                                direction="row"
                                                justify="space-between"
                                                alignItems="center"
                                                spacing={4}
                                            >
                                                <Grid item xs={6}>
                                                    <FormControlLabel
                                                        control={<Checkbox value="isExnel" color="primary" onChange={handleChangeExterneal} checked={isExterneal} />}
                                                        label="External Calibration"
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {externalData && (
                                                        <>
                                                            <Box display="flex" alignItems="flex-start" justifyContent="space-between">

                                                                <Box>
                                                                    <Typography variant="subtitle2">
                                                                        Functionality Check Completed: {externalData.completed}
                                                                    </Typography>

                                                                    <Typography variant="subtitle2">
                                                                        Date: {externalData.date ? new Date(externalData.date).toLocaleDateString() : ""}
                                                                    </Typography>

                                                                    <Typography variant="subtitle2">
                                                                        Notes: {externalData.notes}
                                                                    </Typography>

                                                                </Box>

                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        // open dialog
                                                                        setOpenIsExternalDialog(true);

                                                                        // set existing values into Formik
                                                                        setFieldValue("external_completed", externalData.completed);
                                                                        setFieldValue("external_completed_date", externalData.date);
                                                                        setFieldValue("external_notes", externalData.notes);
                                                                    }}
                                                                >
                                                                    <EditIcon fontSize="small" color="primary" />
                                                                </IconButton>


                                                            </Box>

                                                        </>

                                                    )}
                                                </Grid>


                                                <Grid item xs={6}>
                                                    <Field
                                                        name="lastcalibrateddate"
                                                        component={DateTimePicker}
                                                        format="YYYY-MM-DD"
                                                        style={{ marginBottom: 20 }}
                                                        label="Last calibrated date"
                                                        inputVariant="outlined"
                                                        fullWidth
                                                        helperText={
                                                            touched.lastcalibrateddate ? errors.lastcalibrateddate : ""
                                                        }
                                                        error={
                                                            touched.lastcalibrateddate && Boolean(errors.lastcalibrateddate)
                                                        }
                                                    />
                                                </Grid>


                                                <Grid item xs={6}>
                                                    <Field
                                                        id="schedule_for_the_calibration"
                                                        type="text"
                                                        name="schedule_for_the_calibration"
                                                        fullWidth
                                                        component={TextField}
                                                        label="Schedule for the calibration"
                                                        helperText={
                                                            touched.schedule_for_the_calibration ? errors.schedule_for_the_calibration : ""
                                                        }
                                                        error={
                                                            touched.schedule_for_the_calibration && Boolean(errors.schedule_for_the_calibration)
                                                        }
                                                    >
                                                    </Field>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="h5" color="primary" >Upload Calibration Report  <img onClick={handleFileUpload} src="/file_upload.svg" alt="Custom Icon" width="30" height="30" /></Typography>
                                                </Grid>
                                                <Grid item xs={4}>

                                                    <input
                                                        ref={fileInputRef}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        // accept="image/*,.pdf"
                                                        onChange={handleFilePicked}
                                                    />
                                                    {files.length != 0 && <div style={{ position: "relative", display: "inline-block" }}>
                                                        <img src="/file_icon.png" alt="Custom Icon" height={200} width={200} />
                                                        <IconButton
                                                            style={{
                                                                position: "absolute",
                                                                top: "5px",
                                                                right: "5px",
                                                                background: "lightgray",
                                                                color: "black",
                                                                border: "none",
                                                                borderRadius: "50%",
                                                                width: "40px",
                                                                height: "40px",
                                                            }}
                                                            onClick={() => setFiles([])}
                                                        >
                                                            <Delete></Delete></IconButton>
                                                    </div>}
                                                </Grid>
                                                <Dialog open={openIsExternalDialog} onClose={() => setOpenIsExternalDialog(false)}>
                                                    <DialogTitle>External Calibration</DialogTitle>

                                                    <DialogContent>
                                                        <Grid container spacing={2}>

                                                            {/* Yes / No */}
                                                            <Grid item xs={12}>
                                                                <Field
                                                                    name="external_completed"
                                                                    component={TextField}
                                                                    select
                                                                    label="Is the functionality check completed?"
                                                                    fullWidth
                                                                    SelectProps={{ native: true }}
                                                                >
                                                                    <option value="" disabled hidden>

                                                                    </option>
                                                                    <option value="Yes">Yes</option>
                                                                    <option value="No">No</option>
                                                                </Field>
                                                            </Grid>

                                                            {/* Date */}
                                                            <Grid item xs={12}>
                                                                <Field
                                                                    name="external_completed_date"
                                                                    component={DatePicker}
                                                                    format="YYYY-MM-DD"
                                                                    label="Date Completed"
                                                                    fullWidth
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <Field
                                                                    name="external_notes"
                                                                    component={TextField}
                                                                    label="Comments"
                                                                    multiline
                                                                    rows={3}
                                                                    fullWidth
                                                                />
                                                            </Grid>

                                                        </Grid>
                                                    </DialogContent>

                                                    <DialogActions>
                                                        <Button
                                                            onClick={() => {
                                                                // 1. Close dialog
                                                                setOpenIsExternalDialog(false);

                                                                // 2. Uncheck checkbox
                                                                setExternel(false);

                                                                // 3. Reset Formik fields
                                                                setFieldValue("external_completed", "");
                                                                setFieldValue("external_completed_date", "");
                                                                setFieldValue("external_notes", "");
                                                            }}
                                                            color="secondary"
                                                        >
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            onClick={() => {
                                                                if (!values.external_completed) {
                                                                    toast.error("Please select if functionality check is completed");
                                                                    return;
                                                                }

                                                                if (!values.external_completed_date) {
                                                                    toast.error("Please select completed date");
                                                                    return;
                                                                }

                                                                if (!values.external_notes) {
                                                                    toast.error("Please enter comments");
                                                                    return;
                                                                }
                                                                setExternalData({
                                                                    completed: values.external_completed,
                                                                    date: values.external_completed_date,
                                                                    notes: values.external_notes,
                                                                });

                                                                setOpenIsExternalDialog(false);
                                                            }}
                                                            color="primary"
                                                        >
                                                            Save
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>






                                            </Grid>

                                        )}


                                        <Grid
                                            container
                                            spacing={3}
                                            direction="row"
                                            justify="space-around"
                                            alignItems="center"
                                            style={{ marginTop: 32 }}
                                        >
                                            <Grid item xs={4}>
                                                <Button
                                                    data-testid="submitCrateId"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={submitForm}
                                                >
                                                    ADD ASSET
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </Form>
                                );
                            }}
                        </Formik>
                    </Grid>
                </Grid>
            </Container>

            <NewSubAsset
                open={openDialog}
                onClose={handleCloseDialog}
                handleChildData={handleChildData}
            />

            <Dialog open={confirmDialogOpen} onClose={handleCancel}>
                <DialogTitle>Confirm Main Asset</DialogTitle>
                <DialogContent>
                    Do you want to mark this asset as the Main Asset?
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="secondary">Cancel</Button>
                    <Button onClick={handleConfirm} color="primary">Confirm</Button>
                </DialogActions>
            </Dialog>


        </div>
    )
}